import './_jquery';

$('body a').on('click', function() {
  $('.close-cookie-banner').each(function() {
    $(this)[0].trigger('click');
  });
});
